<div class="ici-types sam-flex-auto">
   <div *ngFor="let iciType of availableIci">
      <samweb-agent-greeting-wave-drop
         [skillId]="skillId"
         [searchValues]="searchValues"
         [draggedItemKey]="draggedItemKey"
         [ici]="iciType | iciTypeByName"
         [disabled]="disabled"
         (waveFileDropped)="drop($event)"
         (removeAssignment)="remove($event)"
         (expandGroup)="expandIciGroup($event)"
      ></samweb-agent-greeting-wave-drop>
   </div>
</div>
